import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getArquivos = createAsyncThunk(
  "ediApp/transportadoras/getArquivos",
  async (data: any, { dispatch }) => {
    let response;
    const { dataHoraInicial, dataHoraFinal, tipoDocumento } = data;
    dispatch(openLoading());
    try {
      response = await API.get(
       `/edi/arquivos-ocorrencias?dataHoraInicial=${dataHoraInicial}&dataHoraFinal=${dataHoraFinal}&tipoDocumento=${tipoDocumento}`
       );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos. Caso estejam, solicite contato com a transportadora.",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);
